// extracted by mini-css-extract-plugin
module.exports = {"image":"ContactForm-module--image--2JuFv"};